import { Hero } from "./components/Hero";
import { Testimonials } from "./components/Testimonials";
import { CTA } from "./components/CTA";
import { Footer } from "./components/Footer";
import { PricingApi } from "./components/PricingApi";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { FAQ } from "./components/FAQ";
import Header from "./components/Header";
import { Features } from "./components/Features";
import { HowItWorks } from "./components/HowItWorks";

export default function Page() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#EE7B11] to-black">
      <h1 className="sr-only">pedidoZ - Gestão de pedidos, clientes e catálogos</h1>
      <Header />
      <Hero />
      <WhyChooseUs />
      <Features />
      <HowItWorks />
      <Testimonials />
      <PricingApi />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
